import { render, staticRenderFns } from "./FlmQuestionnaire.vue?vue&type=template&id=21d82c5e"
import script from "./FlmQuestionnaire.vue?vue&type=script&lang=ts"
export * from "./FlmQuestionnaire.vue?vue&type=script&lang=ts"
import style0 from "./FlmQuestionnaire.vue?vue&type=style&index=0&id=21d82c5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports